export default "__VITE_ASSET__CeUxojPU__"